import React, { createContext, useContext, useMemo, useRef } from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import { getStorage } from "../auth/utils";

const GoogleMapsContext = createContext({ isLoaded: false });
const LIBRARIES = ["places", "marker"];

function resolveLanguage() {
  const stored = getStorage().getItem("language") || "el";
  return stored === "gr" ? "el" : stored;
}

export const GoogleMapsProvider = ({ children }) => {
  // Read once; don't let it change after first render
  const initialLangRef = useRef(resolveLanguage());
  const language = initialLangRef.current;

  // Freeze loader options for this session
  const loaderOptions = useMemo(
    () => ({
      id: `google-map-script-${language}`, // unique but stable for this session
      googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
      version: "weekly",
      language,
      libraries: LIBRARIES,
      // region: "GR", // (optional) set once and keep it fixed as well
    }),
    [] // no deps — do not recompute if React re-renders
  );

  const { isLoaded } = useJsApiLoader(loaderOptions);

  return (
    <GoogleMapsContext.Provider value={{ isLoaded }}>
      {children}
    </GoogleMapsContext.Provider>
  );
};

export const useGoogleMaps = () => useContext(GoogleMapsContext);
